import { Address } from '../../components/Address';
import { OfferGeneralInfoLayout } from '../../components/OfferGeneralInfoLayout';
import { GeoContainer } from '../GeoContainer';
import { OfferHeaderContainer } from '../OfferHeaderContainer';
import { useOfferContext } from '../OfferContext';
import { FeaturesContainer } from '../FeaturesContainer';
import { AboutBuildingContainer } from '../AboutBuildingContainer';

export function OfferGeneralInfoContainer() {
  const {
    geo: { address },
  } = useOfferContext();

  return (
    <OfferGeneralInfoLayout>
      <OfferHeaderContainer />
      <FeaturesContainer />
      <AboutBuildingContainer />
      <GeoContainer />
      <Address address={address} />
    </OfferGeneralInfoLayout>
  );
}
